import {
  GET_ALL_USERS,
  USER_LOGOUT_ADMIN,
  SET_ROLE_PERMISSIONS,
  GET_ADVISOR_USER_PROFILE,
  SET_USERS_TAB_FILTERS,
  SET_USER_NAME_SEARCH_STRING,
  RESET_PAGES,
} from '../actionTypes';

const getInitialState = () => ({
  users: [],
  permissions: {
    accessibleContent: {},
    editableRoles: [],
    usersFilters: {},
  },
  userProfileInfo: [],
  userNameSearchString: '',
  resultPages: 0,
});

const reducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case GET_ALL_USERS: {
      const { users, resultPages } = action.payload;
      return {
        ...state,
        users,
        resultPages,
      };
    }

    case RESET_PAGES: {
      return {
        ...state,
        resultPages: action.payload,
      };
    }

    case SET_USER_NAME_SEARCH_STRING: {
      const { string } = action.payload;
      return {
        ...state,
        userNameSearchString: string,
      };
    }

    case SET_USERS_TAB_FILTERS: {
      const { filters } = action.payload;
      return {
        ...state,
        permissions: {
          ...state.permissions,
          usersFilters: filters,
        },
      };
    }

    case USER_LOGOUT_ADMIN: {
      return getInitialState();
    }

    case SET_ROLE_PERMISSIONS: {
      const { accessibleContent, editableRoles, usersFilters } = action.payload;
      return {
        ...state,
        permissions: {
          accessibleContent,
          editableRoles,
          usersFilters,
        },
      };
    }

    case GET_ADVISOR_USER_PROFILE: {
      return {
        ...state,
        userProfileInfo: action.payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
